// extracted by mini-css-extract-plugin
export default {"root":"ways-to-help-layout-section_root__c3v8L"};